import { differenceInBusinessDays } from 'date-fns';

import {
	confluenceLocalStorageInstance as localStorage,
	PERSISTED_KEYS_ON_SERVER,
} from '@confluence/storage-manager';

interface PremiumMessagesCadence {
	getStorageKEY: () => string | null;
	getMainKey: () => string | null;
	getMessageCadence: () => number;
	setMessageNextCadence: () => void;
	canShowMessage: () => boolean;
	dismissMessage: () => void;
}

export enum PremiumMessages {
	Automation = 'automation',
	Generic = 'generic',
}

export class PremiumMessagesCadenceState implements PremiumMessagesCadence {
	static PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_GENERIC_CADENCE =
		PERSISTED_KEYS_ON_SERVER.PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_GENERIC_CADENCE;
	static PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_AUTOMATION_CADENCE =
		PERSISTED_KEYS_ON_SERVER.PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_AUTOMATION_CADENCE;
	private static expirationTime = 2592000; // 30 days in seconds
	private mainKey: string = '';

	constructor(mainKey: PremiumMessages) {
		this._init(mainKey);
	}

	private _init(mainKey: PremiumMessages) {
		switch (mainKey) {
			case PremiumMessages.Automation:
				this.mainKey =
					PremiumMessagesCadenceState.PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_AUTOMATION_CADENCE;
				break;
			case PremiumMessages.Generic:
				this.mainKey =
					PremiumMessagesCadenceState.PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_GENERIC_CADENCE;
				break;
			default:
				throw new Error('Invalid main key');
		}
	}

	private isStorageKEYDismissed = () => {
		const cadence = this.getMessageCadence();
		return cadence < 0;
	};

	private setStorageKEY = (cadence: number) => {
		const timestamp = Date.now();
		localStorage.setItem(
			this.getMainKey(),
			`${timestamp};${cadence}`,
			PremiumMessagesCadenceState.expirationTime,
		);
	};

	private getDayDifference = () => {
		const timestamp = parseInt(this.getStorageKEY().split(';')[0]);
		const currentDate = Date.now();
		return differenceInBusinessDays(currentDate, timestamp);
	};

	private messageSeenLongerThanADay = () => {
		if (!this.getStorageKEY()) return true;
		return this.getDayDifference() >= 1;
	};

	dismissMessage = () => {
		if (this.isStorageKEYDismissed()) return;
		this.setStorageKEY(-1);
	};

	getMainKey = () => {
		return this.mainKey;
	};

	getStorageKEY = () => {
		return localStorage.getItem(this.getMainKey());
	};

	getMessageCadence = () => {
		if (this.getStorageKEY() === null || this.getStorageKEY() === undefined) return 1;
		return parseInt(this.getStorageKEY().split(';')[1]);
	};

	setMessageNextCadence = () => {
		if (!this.canShowMessage()) return;
		const nextCadence = this.getMessageCadence() + 1;
		if (nextCadence > 5) {
			this.dismissMessage();
			return;
		}
		this.setStorageKEY(nextCadence);
	};

	canShowMessage = () => {
		if (this.isStorageKEYDismissed()) return false;
		if (this.getMessageCadence() > 5) return false;
		if (!this.messageSeenLongerThanADay()) return false;

		return true;
	};
}
